export const aboutData = {
  brandIntro: {
    title: '关于红桃影院',
    subtitle: '您的高清影视娱乐首选平台',
    description: '红桃影院成立于2020年，是一家专注于在线影视内容分发的高科技互联网平台。我们致力于为全球华语用户提供海量高清电影、电视剧、动漫、综艺等影视内容的免费观看服务。凭借强大的技术团队和丰富的版权资源，红桃影院已发展成为国内领先的影视娱乐平台之一。',
    mission: '我们的使命是让每一个人都能轻松享受高品质的影视娱乐内容，打破时间和空间的限制，用科技连接精彩世界。',
    vision: '成为全球最受用户信赖和喜爱的华语影视平台，引领在线影视行业的创新发展。',
    stats: [
      { value: '10万+', label: '影视资源' },
      { value: '5000万+', label: '月活用户' },
      { value: '99.9%', label: '服务可用率' },
      { value: '4.8', label: '用户评分' },
    ],
  },
  reputation: {
    title: '用户口碑',
    subtitle: '来自真实用户的高度评价',
    reviews: [
      {
        name: '张先生',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20professional%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20friendly%20expression%2C%20clean%20corporate%20style%2C%20studio%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
        rating: 5,
        date: '2026-07-15',
        content: '红桃影院真的是我目前用过最好的免费影视平台！资源特别全，更新速度也很快，最新的大片基本都能第一时间看到。画质也很清晰，而且完全没有广告，观影体验一级棒！强烈推荐给身边所有朋友了。',
      },
      {
        name: '李女士',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20professional%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20warm%20smile%2C%20clean%20corporate%20style%2C%20studio%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
        rating: 5,
        date: '2026-07-12',
        content: '每天下班回家就打开红桃影院追剧，资源太丰富啦！韩剧美剧国产剧应有尽有，而且手机和电脑上都能看，非常方便。分类找片也很容易，好评好评！',
      },
      {
        name: '王同学',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20student%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20casual%20friendly%20expression%2C%20studio%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
        rating: 5,
        date: '2026-07-08',
        content: '作为一个动漫迷，红桃影院的动漫资源真的太赞了！日漫新番更新特别及时，国漫精品也都有收录。播放流畅不卡顿，追番神器就是它！',
      },
      {
        name: '赵先生',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20man%20professional%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20friendly%20smile%2C%20studio%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish',
        rating: 4,
        date: '2026-07-05',
        content: '用了好几个影视平台，最后还是觉得红桃影院最顺手。界面简洁漂亮，找片很方便，没有乱七八糟的弹窗广告。希望资源能继续丰富下去，越做越好！',
      },
      {
        name: '刘女士',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20young%20professional%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20friendly%20expression%2C%20clean%20corporate%20style%2C%20studio%20lighting&width=80&height=80&seq=avatar-05&orientation=squarish',
        rating: 5,
        date: '2026-06-28',
        content: '带娃的妈妈党表示红桃影院简直是救星！偶尔想放松一下，打开就能找到想看的电影和综艺。投屏到电视上画质也很棒，全家一起看特别温馨。',
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '如有任何问题或建议，欢迎随时联系我们',
    email: 'contact@hongtao.tv',
    wechat: '红桃影院官方',
    weibo: '@红桃影院',
    workingHours: '周一至周日 9:00 - 22:00',
    address: '中国广东省深圳市南山区科技园南路88号',
  },
};